<template>
  <div class="row" v-if="!userRolesLoading">
    <div class="col-sm-6 col-12 dashboard-users-success pr-1">
      <div class="card text-center">
        <div class="card-body py-1">
          <div
            class="
              badge-circle badge-circle-lg badge-circle-light-primary
              mx-auto
              mb-50
            "
          >
            <i class="bx bxs-group font-medium-5"></i>
          </div>
          <div class="text-muted line-ellipsis">
            {{ $t("dashboard.total_user_count") }}
          </div>
          <h3 class="mb-0">{{ roles }}</h3>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-12 dashboard-users-success pr-1">
      <div class="card text-center">
        <div class="card-body py-1">
          <div
            class="
              badge-circle badge-circle-lg badge-circle-light-primary
              mx-auto
              mb-50
            "
          >
            <i class="bx bxs-building font-medium-5"></i>
          </div>
          <div class="text-muted line-ellipsis">
            {{ $t("dashboard.store_user_count") }}
          </div>
          <h3 class="mb-0">{{ storeUser.role_count }}</h3>
        </div>
      </div>
    </div>
    <div class="col-sm-4 col-12 dashboard-users-success pr-1">
      <div class="card text-center">
        <div class="card-body py-1">
          <div
            class="
              badge-circle badge-circle-lg badge-circle-light-primary
              mx-auto
              mb-50
            "
          >
            <i class="bx bxs-id-card font-medium-5"></i>
          </div>
          <div class="text-muted line-ellipsis">
            {{ $t("dashboard.corporate_user_count") }}
          </div>
          <h3 class="mb-0">{{ corporateUser.role_count }}</h3>
        </div>
      </div>
    </div>
    <div class="col-sm-4 col-12 dashboard-users-success pr-1">
      <div class="card text-center">
        <div class="card-body py-1">
          <div
            class="
              badge-circle badge-circle-lg badge-circle-light-primary
              mx-auto
              mb-50
            "
          >
            <i class="bx bx-run font-medium-5"></i>
          </div>
          <div class="text-muted line-ellipsis">
            {{ $t("dashboard.field_user_count") }}
          </div>
          <h3 class="mb-0">{{ field.role_count }}</h3>
        </div>
      </div>
    </div>
    <div class="col-sm-4 col-12 dashboard-users-success pr-1">
      <div class="card text-center">
        <div class="card-body py-1">
          <div
            class="
              badge-circle badge-circle-lg badge-circle-light-primary
              mx-auto
              mb-50
            "
          >
            <i class="bx bxs-cog font-medium-5"></i>
          </div>
          <div class="text-muted line-ellipsis">
            {{ $t("dashboard.operator_user_count") }}
          </div>
          <h3 class="mb-0">{{ operator.role_count }}</h3>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-else>
    <div class="col-12">
      <LoadingBox></LoadingBox>
    </div>
  </div>
</template>
  
<script>
import LoadingBox from "@/assets/components/loader/LoadingBox.vue";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput.vue";
import baseModule, {
  ERROR,
  SUCCESS,
  MODULE_NAME,
  USER_ROLES,
  GET_USER_ROLES,
  GET_USER_ROLES_LOADING,
} from "@/core/services/store/dashboard.module";
import store from "@/core/services/store";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "DashboardInstitutionBranchesMaps",
  components: {
    MultipleSelectInput,
    LoadingBox,
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(_MODULE_NAME, baseModule);
  },
  computed: {
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    userRolesLoading() {
      return store.getters[_MODULE_NAME + "/" + GET_USER_ROLES_LOADING];
    },
    userRoles() {
      return store.getters[_MODULE_NAME + "/" + USER_ROLES];
    },
    roles() {
      let roles = this.userRoles;
      if (!roles) return 0;
      return roles.totalUserCount;
    },
    operator() {
      let roles = this.userRoles;
      if (!roles) return 0;
      return roles.rolesCount.find((item) => item.id == 2);
    },
    field() {
      let roles = this.userRoles;
      if (!roles) return 0;
      return roles.rolesCount.find((item) => item.id == 3);
    },
    corporateUser() {
      let roles = this.userRoles;
      if (!roles) return 0;
      return roles.rolesCount.find((item) => item.id == 4);
    },
    storeUser() {
      let roles = this.userRoles;
      if (!roles) return 0;
      return roles.rolesCount.find((item) => item.id == 5);
    },
  },
  methods: {
    filterResults() {
      this.$store.dispatch(_MODULE_NAME + "/" + GET_USER_ROLES, {});
    },
  },
  mounted() {
    this.filterResults();
  },
};
</script>
    
    <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
#institionSelect {
  position: absolute;
  z-index: 99;
  top: 4px;
  width: 350px;
  right: 20px;
}
.map-section {
  height: 500px;
  position: relative;
  overflow: hidden;
}

.map-info-window {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: #fff;
}

.map-info-window-slide-leave-active,
.map-info-window-slide-enter-active {
  transition: 0.5s;
}

.map-info-window-slide-enter {
  transform: translate(0, -100%);
}

.map-info-window-slide-leave-to {
  transform: translate(0, -100%);
}

.city-info > div {
  margin-bottom: 10px;
}

.map-btn-close-holder {
  margin-top: 10px;
}
</style>
    